export const PRODUCT_CATEGORY_REQUESTS_CODES = {
  PCR003: 'productCategoryRequestExist',
};
